import fetch from './fetch.js'
import { scrollToElement } from './utils.js'

let $forms = Array.from(document.querySelectorAll('.js-form'))

$forms.forEach(init)

function init ($form) {
  $form.addEventListener('submit', onSubmit)
}

function onSubmit (e) {
  e.preventDefault()

  let $form = e.target

  if (window.recaptchaSiteKey) {
    grecaptcha.ready(() => {
      grecaptcha
        .execute(window.recaptchaSiteKey, {
          action: e.target.elements['form'].value
        })
        .then((token) => {
          e.target.elements['recaptcha_response'].value = token
          submit($form)
        })
    })
  } else {
    submit($form)
  }
}

function submit($form)
{
  let action = $form.action
  let method = $form.method || 'POST'
  let body = new window.FormData($form)

  let $submit = $form.querySelector(
    'button[type="submit"], input[type="submit"]'
  )

  $submit.disabled = true

  fetch(action, {
    method,
    body,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(res => {
      if (res.status !== 200 && res.status !== 400) {
        return false
      }
      return res.json()
    })
    .then(res => {
      if (res) {
        if (res.errors) {
          Array.from($form.querySelectorAll('.is-invalid')).forEach($x => {
            $x.classList.remove('is-invalid')
          })
          Array.from($form.querySelectorAll('.error')).forEach($x => {
            $x.parentNode.removeChild($x)
          })
          Object.keys(res.errors).forEach(name => {
            let $input =
              $form.querySelector(`[name="${name}"]`) ||
              $form.querySelector(`[name="${name.replace(/_/g, ' ')}"]`)

            let $field = $input.closest('.js-field')

            $field.classList.add('is-invalid')
            let $msg = document.createElement('p')
            $msg.className = 'error text-red text-sm mt-2'
            $msg.textContent = `* ${res.errors[name]}`
            $field.appendChild($msg)
          })
          $submit.disabled = false
        } else {
          let $statusText = document.getElementById(
            $form.getAttribute('data-success')
          )
          if ($form.hasAttribute('data-success-msg')) {
            $statusText.innerText = $form.getAttribute('data-success-msg')
          }
          $statusText.hidden = false
          $form.parentNode.removeChild($form)
          scrollToElement($statusText, false, 'middle');

          if ('download' in res) {
            const link = document.createElement('a');
            link.href = res.download;
            link.setAttribute('target', '_blank');
            link.rel = 'noopener noreferrer';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          // Trigger for GTM
          window.dataLayer = window.dataLayer || [];

          window.dataLayer.push({
            event: 'form_submission'
          });
        }
      } else {
        let $statusText = document.getElementById(
          $form.getAttribute('data-success')
        )
        if (typeof $form.getAttribute('data-error') !== 'undefined') {
          $statusText.innerText = $form.getAttribute('data-error')
          $statusText.hidden = false
          $submit.disabled = false
        }
      }
    })
}



// WEBPACK FOOTER //
// ./src/js/_form.js